import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field, useField } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    stackStyling,
    formLabelStyling,
    descriptionStyling,
    stackSpacing,
} from 'components/forms/new/formStyles';
import { ITEM_CODE_OPTIONS } from '../add/constants';

const itemCodeData = ITEM_CODE_OPTIONS.map((option) => ({
    id: option.value,
    name: option.label,
}));

const ItemCodeField = ({ darkMode, mode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [, meta] = useField('itemCode');
    const error = meta.error;
    const showError = meta.touched;

    return (
        <FormControl
            sx={{ margin: '0 0 24px 0 !important', width: '100%' }}
            isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                alignItems="flex-start"
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Item Code <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the type of item for this invoice line.
                    </Text>
                </Box>
                <Box minWidth="450px" flex="1">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '20px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                component={DropDown}
                                name="itemCode"
                                data={itemCodeData}
                                shownValue="name"
                                placeholder="- Select Item Code -"
                                handleSelectChange={() => {}}
                                darkMode={darkMode}
                                isDisabled={mode === 'Delete'}
                                noPadding
                                width="100%"
                            />
                            {showError && (
                                <Text
                                    color="red.500"
                                    fontSize="xs"
                                    mt={1}
                                    textAlign="right">
                                    {error}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the type of item for this invoice line"
                        ariaLabel="item-code-tip"
                        left="25px"
                        top="30px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ItemCodeField;
